// This file is used by our deployment pipeline. The placeholders will be replaced by actual values
// coming from SSM Parameter Store.

import type { Environment } from './environment.type';

export const environment: Environment = {
  production: true,
  appReleaseVersion: 'e45960bf',
  appUiUrl: 'https://staging.davies.squadbox.ai',
  appApiUrl: 'https://api.staging.davies.squadbox.ai',
  appHelpCenterUrl: {
    en: 'https://squadbox.notion.site/help-center',
    fr: 'https://squadbox.notion.site/centre-daide',
  },
  appTermsAndConditionsUrl: {
    en: 'https://www.squadbox.ai/tos',
    fr: 'https://www.squadbox.ai/tcs',
  },
  appReleaseNotesUrl: {
    en: 'https://squadbox.notion.site/Release-Notes-1d5ec51774fc803ab233e6c1ea33a346',
    fr: 'https://squadbox.notion.site/Mises-jour-1f9ec51774fc81be8aa0db0ece7bdce5',
  },
  buildNumber: '20260729.1653.1',
  refreshTokensTimerDue: +'300000',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore Will be replaced by valid values during deployment
  speechToTextProvider: 'azure',
  azureSpeechToTextRegion: 'canadacentral',
  deepgramBaseUrl: 'api.eu.deepgram.com',
  sentryOptions: {
    dsn: 'https://c7b7c43c20b97fdf8360460bfe7e50ee@o4511111741702144.ingest.us.sentry.io/4508202231726080',
    environment: 'davies-staging',
    release: '20260729.1653.1',
  },
  launchDarkly: {
    envKey: '67250f2d1a3154080d025250',
    context: {
      kind: 'multi',
      user: {
        anonymous: true,
      },
      client: {
        key: 'davies',
        name: 'davies',
      },
      device: {
        anonymous: true,
      },
      browser: {
        anonymous: true,
      },
    },
    options: {
      bootstrap: 'localStorage',
      application: {
        id: 'squadbox-ui-davies-staging',
        version: '20260729.1653.1',
      },
    },
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore Will be replaced by valid values during deployment
  defaultLanguage: 'en',
  assistantPromptMaxLength: +'55000',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  cognitoIdpConfig: () => JSON.parse(atob('W3siZG9tYWluIjpudWxsLCJpZHAiOiJlbnRyYS1pZCIsImlkcEN1c3RvbUlkIjoiRW50cmFJRCJ9XQ==')),
  // SB-3337: hardcoded literal, NOT a deploy-time placeholder (KD-2/KD-9).
  hsIdpCustomId: 'GoogleWorkspace-HS',
  jiraIssueCollector: {
    scriptBaseUrl:
      'https://halfserious.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/xghl7j/b/0/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js',
    collectorId: '0a213ab5',
    customFieldIds: {
      clientEmail: '11708',
      clientName: '11774',
    },
  },
  maxFileUploadSizeInMB: +'50',
  refiner: {
    environmentId: 'a4e8b980-4f9f-11f1-9544-b1bdb1800207',
  },
};
